export default "__VITE_ASSET__28ada981__"